import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import Link from 'components/link'
import { Col, Row } from 'react-bootstrap'
import { InfoButton } from 'components/buttons'
import * as blUrls from 'lib/urls'
import { CONFIG } from 'shared/constants'
import {
  getEligibleForRegistryDiscount,
  getRegistryUrlSlug,
} from 'registry/reducers'
import CategoryGrid from 'store/components/CategoryGrid'

export class RegistryDiscountStatus extends Component {
  static propTypes = {
    isEligibleForRegistryDiscount: PropTypes.bool.isRequired,
    slug: PropTypes.string.isRequired,
  }

  render() {
    if (this.props.isEligibleForRegistryDiscount) {
      return <EligibleForDiscount slug={this.props.slug} />
    } else {
      return <NotYetEligibleForDiscount />
    }
  }
}

const EligibleForDiscount = ({ slug }) => (
  <div>
    <div>
      <p className="mbxl">
        You'll see your registry discount during the checkout process and can
        opt to use it one time on any order.
      </p>
      <Row className="mbxl">
        <Col xs={12} smOffset={1} sm={5}>
          <InfoButton block empty href={blUrls.shopRegistryPath}>
            Shop Your Registry
          </InfoButton>
        </Col>
        <Col xs={12} sm={5} className="mtl mtn-sm">
          <InfoButton block empty href={blUrls.storePath}>
            Shop Our Store
          </InfoButton>
        </Col>
      </Row>
    </div>
    <p className="h6 mbn">
      *Read more about our registry discount program{' '}
      <Link url={blUrls.registryDiscountPath}>here</Link>.
    </p>
  </div>
)

const NotYetEligibleForDiscount = () => (
  <div>
    <div>
      <p className="mbxl">
        You'll be eligible for your {CONFIG.store.registryDiscountPctDisplay}{' '}
        discount on products from the Babylist shop 60 days before your babe's
        arrival date.*
      </p>
      <CategoryGrid smallGutter categories={categories} useRouter={false} />
      <div className="text-center mbxl">
        <InfoButton empty href={blUrls.storePath}>
          Add Items From Our Store
        </InfoButton>
      </div>
    </div>
    <p className="h6 mbn">
      *Read more about our registry discount program{' '}
      <Link url={blUrls.registryDiscountPath}>here</Link>.
    </p>
  </div>
)

const categories = [
  {
    imageUrl:
      'https://images.ctfassets.net/50gzycvace50/3afab83b4cc2c0739986403a50f5d260bc140b9d734e55034b8745e364b13ba2/1afb8f56ffb0253193c4e693daca5450/3afab83b4cc2c0739986403a50f5d260bc140b9d734e55034b8745e364b13ba2.png?fl=progressive&fm=jpg&bg=rgb:f9f9f9&w=320&h=320',
    title: 'Shop our most popular',
    urlSlug: '',
  },
  {
    imageUrl:
      'https://images.ctfassets.net/50gzycvace50/61U6jEYJZmkeyU86kGckEq/406ad0312f6cc0bba900e24b91cb47f3/2_generic_13643_13644_13645_lifestyle.jpg?bg=rgb:f9f9f9&fit=fill&fl=progressive&fm=jpg&w=500&h=500',
    title: 'Build your nursery',
    urlSlug: '/nursery',
  },
  {
    imageUrl:
      'https://images.ctfassets.net/50gzycvace50/44NN2IrvJS0oOa6Gic80Im/8b1f7db6e87a2a9f7adbdf7e21b79013/1_Britax_B-Agile-3-Stroller_Black_Right-Angle_17115_transparent.png?bg=rgb:f9f9f9&fit=fill&fl=progressive&fm=jpg&w=500&h=500',
    title: 'Select your stroller',
    urlSlug: '/strollers',
  },
]

const mapStateToProps = (state) => {
  return {
    isEligibleForRegistryDiscount: getEligibleForRegistryDiscount(state),
    slug: getRegistryUrlSlug(state),
  }
}
export default connect(mapStateToProps)(RegistryDiscountStatus)
